module.exports = __webpack_public_path__ + "static/img/hover-iocn61.49a161d.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/add_icon/hover-iocn61.png
// module id = pyI/
// module chunks = 1